if (!customElements.get('sticky-buy-bar')) {
  customElements.define(
    'sticky-buy-bar',
    class StickyBuyBar extends HTMLElement {
      constructor() {
        super();

        this.sectionId = this.dataset.section;
        this.priceSource = document.getElementById(`price-${this.sectionId}`);
        this.submitSource = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.priceTarget = this.querySelector('[data-sticky-price]');
        this.button = this.querySelector('[data-sticky-submit]');
        this.buttonText = this.querySelector('[data-sticky-submit-text]');

        this.applyBodyPadding = this.applyBodyPadding.bind(this);

        this.syncPrice();
        this.syncButtonState();

        if (this.priceSource) {
          this.priceObserver = new MutationObserver(this.syncPrice.bind(this));
          this.priceObserver.observe(this.priceSource, {
            childList: true,
            subtree: true,
            characterData: true,
          });
        }

        if (this.submitSource) {
          this.buttonObserver = new MutationObserver(this.syncButtonState.bind(this));
          this.buttonObserver.observe(this.submitSource, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled'],
            childList: true,
            subtree: true,
            characterData: true,
          });
        }
      }

      connectedCallback() {
        this.applyBodyPadding();

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.applyBodyPadding);
          this.resizeObserver.observe(this);
        }
        window.addEventListener('resize', this.applyBodyPadding);
      }

      disconnectedCallback() {
        this.priceObserver?.disconnect();
        this.buttonObserver?.disconnect();
        this.resizeObserver?.disconnect();
        window.removeEventListener('resize', this.applyBodyPadding);
        document.body.style.removeProperty('--sticky-buy-bar-height');
      }

      syncPrice() {
        if (!this.priceSource || !this.priceTarget) return;
        this.priceTarget.innerHTML = this.priceSource.innerHTML;
      }

      syncButtonState() {
        if (!this.submitSource || !this.button) return;

        const isDisabled =
          this.submitSource.disabled || this.submitSource.getAttribute('aria-disabled') === 'true';

        this.button.disabled = isDisabled;
        this.button.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');

        // ラベルのみ独自指定。購入可能なときは data-submit-label を出し、
        // 売り切れ・販売終了のときだけ本体ボタンの文言をそのまま引き継ぐ。
        const sourceText = this.submitSource.querySelector('span')?.textContent?.trim();
        if (this.buttonText) {
          if (isDisabled) {
            if (sourceText) this.buttonText.textContent = sourceText;
          } else if (this.dataset.submitLabel) {
            this.buttonText.textContent = this.dataset.submitLabel;
          }
        }
      }

      applyBodyPadding() {
        const isVisible = window.getComputedStyle(this).display !== 'none';
        document.body.style.setProperty('--sticky-buy-bar-height', isVisible ? `${this.offsetHeight}px` : '0px');
      }
    }
  );
}
